import _ from "lodash/fp";
import React from "react";
import {connect} from "react-redux";
import {fetchSigntask} from "../../stores/signtasks/fetchSigntask";
import {fetchOrderStatus} from "../../stores/signtasks/fetchOrderStatus";
import Properties from "./Properties";
import Signers from "./Signers";
import Documents from "./Documents";
import { withTranslation } from 'react-i18next';

export default withTranslation()(connect(
  state => ({
    data: state.signtasks.data
  }),
  dispatch => ({
    fetchSigntask: _.compose(dispatch, fetchSigntask),
    fetchOrderStatus: _.compose(dispatch, fetchOrderStatus)
  }),
)(class extends React.Component {
  componentDidMount = async () => {
    const id = this.props.match.params.id;
    await this.props.fetchSigntask(id);
    this.props.fetchOrderStatus(id);
  };

  render () {
    const id = this.props.match.params.id;
    const signtask = this.props.data[id];
    const { t } = this.props;

    return signtask ? (
      <div>
        <h4>{t("sign_task_status")}</h4>
        <Properties signtask={signtask} deactivate={true} />
        <h4>{t("sign_task_signers")}</h4>
        <Signers signtask={signtask} signers={signtask.signers} documents={signtask.documents} />
        <h4>{t("sign_task_documents")}</h4>
            <Documents signtaskId={signtask.id} externalReference={signtask.reference} documents={signtask.documents} />
      </div>
    ) : (
      <div>{t("sign_task_loading")}</div>
    );
  }
}));